// extracted by mini-css-extract-plugin
export default {"button":"OrangeButton_button__LcSav","ant-btn-loading":"OrangeButton_ant-btn-loading__l+IxD","ant-btn-loading-icon":"OrangeButton_ant-btn-loading-icon__riJS4"};